import React from 'react';
import { Navbar } from '../components/Navbar';
import { SupportUsPage } from '../components/SupportUsPage';
import { Footer } from '../components/Footer';
export const SupportUs = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2369">
      <Navbar data-id="element-2370" />
      <SupportUsPage data-id="element-2371" />
      <Footer data-id="element-2372" />
    </div>;
};